/* @flow */
import React from 'react';
import cx from 'classnames';

import Activity from 'entities/Activity';
import Avatar from 'components/Avatar.jsx';
import Text from 'components/Text.jsx';
import Time from 'components/Time.jsx';

type Props = {
  activity: Activity,
  className?: ?string,
};

class ChatListActivityItem extends React.Component {
  props: Props;

  render() {
    const { activity } = this.props;
    const summary = activity.getRecipientSummary();
    const startAtDate = activity.getStartAt();

    return (
      <div className={cx('ChatListActivities-item', this.props.className)}>
        <div className="ChatListActivities-item-droplet">
          <Avatar colorHex="c4c6c9" date={startAtDate} size="medium" />
        </div>
        <div className="ChatListActivities-item-body">
          <div className="ChatListActivities-item-body-header">
            <Text truncate className="ChatListActivities-item-body-header-title">
              {activity.getTitle()}
            </Text>

            {startAtDate &&
              <div className="ChatListActivities-item-body-header-date">
                <Time
                  date={startAtDate}
                  month="short"
                  day="2-digit"
                />
              </div>
            }
          </div>
          <div className="ChatListActivities-item-body-subtext">
            {summary.getAttendingCount()} participants
          </div>
          <hr className="ChatListActivities-item-divider" />
        </div>
      </div>
    );
  }
}

export default ChatListActivityItem;



// WEBPACK FOOTER //
// ./src/chat/components/ChatListActivityItem.jsx